import { call, put } from 'redux-saga/effects';

import { apiGeneral, notify } from 'services';
import { IFechRequest } from 'interfaces/fetch-duck';
import { requestErrorHandler } from 'utils';
import { FetchCarrierAreaContactActions } from 'store/ducks/settings/carrier-area-contact';

export function* fetchCarrierAreaContactRequest(action: any) {
  try {
    const { id, onSuccess } = action as IFechRequest;
    const { data } = yield call(apiGeneral.get, `/carrier/contacts/${id}`);

    yield put(FetchCarrierAreaContactActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(FetchCarrierAreaContactActions.failure(errorMessage));
  }
}
